export default {
  events: {
    detailTitle: "Event detail",
    close: "Close",
    product: "Product",
    ingredientLab: "Active ingredient · company",
    whatHappened: "What happened",
    whyItMatters: "Why it matters",
    source: "Source",
    openDocument: "source document",
    confirmedBy: "confirmed by {n} sources",
    published: "Published",
    detected: "Detected",
    relationOwn: "Own product",
    relationCompetitor: "Competitor",
    relationMarket: "Market",
    colDetail: "Detail",
    colBlock: "Block",
    nregistro: "Registration no.",
    sourceSince: "monitored since {date}",
    openEvent: "Open the event detail",
  },
};
